// ===============================
// pages/NewArrivals.jsx
// ===============================

import React from "react";
import "./NewArrivals.css";

const NewArrivals = () => {
  return (
    <div className="new-page">

      <div className="page-banner">
        <h1>New Arrivals</h1>
      </div>

      <div className="container arrivals-grid">

        <div className="arrival-card">
          <img
            src="https://images.unsplash.com/photo-1542291026-7eec264c27ff"
            alt=""
          />

          <h3>Stylish Sneakers</h3>

          <button>
            View Product
          </button>
        </div>

        <div className="arrival-card">
          <img
            src="https://images.unsplash.com/photo-1523398002811-999ca8dec234"
            alt=""
          />

          <h3>Leather Jacket</h3>

          <button>
            View Product
          </button>
        </div>

      </div>

    </div>
  );
};

export default NewArrivals;